import store from "@store/index";
import { setTime } from "@reducers/TimeSlice";

setInterval(() => {
  const currentTime = store.getState().Time.data.current;

  store.dispatch(setTime(currentTime + 1000));
}, 1000);
